import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { type Coverage } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type GetEnrollmentCoveragesQueryArgs = {
  enrollmentId: string
  memberId: string
}

export function getEnrollmentCoveragesQueryKey ({
  enrollmentId,
  memberId,
}: GetEnrollmentCoveragesQueryArgs) {
  return [
    'brokers',
    'members',
    memberId,
    'enrollments',
    enrollmentId,
    'coverages',
  ]
}

export function useGetEnrollmentCoverages ({
  enrollmentId,
  memberId,
}: GetEnrollmentCoveragesQueryArgs) {
  return useQuery<Coverage[], GrapeAPIErrorType>({
    queryKey: getEnrollmentCoveragesQueryKey({ enrollmentId, memberId }),
    queryFn: async () => {
      const response = await fetchWithHeaders(
        `/api/web/brokers/members/${memberId}/enrollments/${enrollmentId}/coverages`
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    retry: false,
  })
}
